export const product_groups = Object.freeze([
    {
        id: 2,
        name: "Древесина",
        code: "002",
        bearer: false,
        checkBox: true,
        load: false,
        categories: [
            {
                key: "card",
                labelRu: "Карточка товара",
                labelKz: "Тауар картасы",
                fields: [
                    { labelRu: "Полное наименование ЮИ", labelKz: "ЮИ толық атауы", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "Дата и время публикации", labelKz: "Жарияланған күні мен уақыты", value: "createdAt" },
                    { labelRu: "Краткое наименование ЮИ", labelKz: "ЮИ қысқаша атауы", valueRu: "shortNameRu", valueKz: "shortNameKz" },
                    // { labelRu: "ИИН/БИН создателя карточки ЮИ", labelKz: "ЮИ картасын құрғанның ЖСН/БСН", value: "applicant" },
                ],
            },
            {
                key: "description",
                labelRu: "Описание товара",
                labelKz: "Тауар сипаттамасы",
                fields: [
                    // { labelRu: "Тип изделия", labelKz: "Бұйым түрі", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "NTIN (Штрихкод)", labelKz: "NTIN (Штрихкод)", value: "ntin" },
                    // { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    // { labelRu: "Расшифровка ТНВЭД", labelKz: "ТН ВЭД түсіндірмесі", valuePath: "tnved.0.tnvedLabel" },
                    // { labelRu: "Код КПВЭД", labelKz: "КПВЭД коды", valuePath: "kpved.0.kpvedCode" },
                    // { labelRu: "Расшифровка КПВЭД", labelKz: "КПВЭД түсіндірмесі", valuePath: "kpved.0.kpvedLabel" },
                    // { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Наименование производителя", labelKz: "Өндірушінің атауы", valueRu: "producerRu", valueKz: "producerKz" },
                    { labelRu: "ИИН/БИН производителя", labelKz: "Өндірушінің ЖСН/БСН", valueRu: "producerBinIin",  },
                    { labelRu: "Товарный знак (марка, бренд) ", labelKz: "Тауар таңбасы (маркасы, бренд)", value: "brand" },
                    { labelRu: "GTIN", labelKz: "GTIN", value: "gtin" },
                    { labelRu: "Наименование кода ОКТРУ", labelKz: "ОКТРУ кодының атауы", value: "oktruLabelRu"},
                    { labelRu: "Код ОКТРУ", labelKz: "ОКТРУ коды", value: "oktruCode" },
                    { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    { labelRu: "Товар категории СЗПТ", labelKz: "СЗПТ санатындағы тауар", value: "szpt",},
                    { labelRu: "Артикул", labelKz: "Артикул (артикул нөмірі)", value: "article",},
                    { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Заводской номер / MPN", labelKz: "Зауыт нөмірі / Өндіруші бөлшек нөмірі (MPN)", value: "mpnCode" },
                    { labelRu: "NTIN", labelKz: "NTIN", value: "ntin" },
                   
                ],
            },
            {
                key: "characteristics",
                labelRu: "Характеристики",
                labelKz: "Сипаттамалар",
                fields: [
                    // { labelRu: "Основной материал", labelKz: "Материал", value: "metal" },
                    // { labelRu: "Соответствие пробы", labelKz: "Проба", value: "purity" },
                    // { labelRu: "Покрытие", labelKz: "Қаптама", valueRu: "coatingRu", valueKz: "coatingKz" },
                    // { labelRu: "Артикул", labelKz: "Артикул", value: "article" },
                    // { labelRu: "Товарный знак", labelKz: "Тауар белгісі", value: "brand" },
                    { labelRu: "Единица измерения товара", labelKz: "Тауардың өлшем бірлігі", value: "measureUnitLabelRu" },
                    { labelRu: "Код единицы измерения", labelKz: "Өлшем бірлігінің коды", value: "measureUnitCode" },
                    { labelRu: "Масса товара без упаковки", labelKz: "Тауардың қаптамасыз салмағы", value: "weightNetto" },
                    { labelRu: "Мера измерения ", labelKz: "Өлшем (өлшем түрі)", value: "weightNettoMeasureUnitLabelRu" },
                    { labelRu: "Код меры измерения", labelKz: "Өлшем түрінің коды", value: "weightNettoMeasureUnitCode" },


                ],
            },
            {
                key: "personal",
                labelRu: "Персональные характеристики",
                labelKz: "Жеке сипаттамалар",
                fields: [
                    { labelRu: "Тип древесины", labelKz: "Сүрек түрі", valuePath: "woodInfo.woodType" },
                    { labelRu: "Порода древесины", labelKz: "Сүрек тұқымы", valuePath: "woodInfo.woodSpecies" },
                    { labelRu: "Номер билета", labelKz: "Билет нөмірі", valuePath: "woodInfo.ticketNumber" },
                    { labelRu: "Объем леса (в м3)", labelKz: "Ағаш көлемі (м3)", valuePath: "woodInfo.forestVolume" },
                    { labelRu: "Дата изготовления", labelKz: "Жасалған күні", valuePath: "woodInfo.manufactureDate" },
                ],
            },
            // {
            //     key: "insertion",
            //     labelRu: "Вставки",
            //     labelKz: "Кірістіру",
            //     fields: [
            //         {
            //             "insertionMaterial": "Бриллиант",
            //             "insertionCount": 3,
            //             "insertionWeight": "15"
            //         }
            //     ],
            // },
        ],
    },
    {
        id: 3,
        name: "Сжиженный нефтяной газ",
        code: "003",
        bearer: false,
        checkBox: true,
        load: false,
        categories: [
            {
                key: "card",
                labelRu: "Карточка товара",
                labelKz: "Тауар картасы",
                fields: [
                    { labelRu: "Полное наименование ЮИ", labelKz: "ЮИ толық атауы", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "Дата и время публикации", labelKz: "Жарияланған күні мен уақыты", value: "createdAt" },
                    { labelRu: "Краткое наименование ЮИ", labelKz: "ЮИ қысқаша атауы", valueRu: "shortNameRu", valueKz: "shortNameKz" },
                    // { labelRu: "ИИН/БИН создателя карточки ЮИ", labelKz: "ЮИ картасын құрғанның ЖСН/БСН", value: "applicant" },
                ],
            },
            {
                key: "description",
                labelRu: "Описание товара",
                labelKz: "Тауар сипаттамасы",
                fields: [
                    // { labelRu: "Тип изделия", labelKz: "Бұйым түрі", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "NTIN (Штрихкод)", labelKz: "NTIN (Штрихкод)", value: "ntin" },
                    // { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    // { labelRu: "Расшифровка ТНВЭД", labelKz: "ТН ВЭД түсіндірмесі", valuePath: "tnved.0.tnvedLabel" },
                    // { labelRu: "Код КПВЭД", labelKz: "КПВЭД коды", valuePath: "kpved.0.kpvedCode" },
                    // { labelRu: "Расшифровка КПВЭД", labelKz: "КПВЭД түсіндірмесі", valuePath: "kpved.0.kpvedLabel" },
                    // { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Наименование производителя", labelKz: "Өндірушінің атауы", valueRu: "producerRu", valueKz: "producerKz" },
                    { labelRu: "ИИН/БИН производителя", labelKz: "Өндірушінің ЖСН/БСН", valueRu: "producerBinIin",  },
                    { labelRu: "Товарный знак (марка, бренд) ", labelKz: "Тауар таңбасы (маркасы, бренд)", value: "brand" },
                    { labelRu: "GTIN", labelKz: "GTIN", value: "gtin" },
                    { labelRu: "Наименование кода ОКТРУ", labelKz: "ОКТРУ кодының атауы", value: "oktruLabelRu"},
                    { labelRu: "Код ОКТРУ", labelKz: "ОКТРУ коды", value: "oktruCode" },
                    { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    { labelRu: "Товар категории СЗПТ", labelKz: "СЗПТ санатындағы тауар", value: "szpt",},
                    { labelRu: "Артикул", labelKz: "Артикул (артикул нөмірі)", value: "article",},
                    { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Заводской номер / MPN", labelKz: "Зауыт нөмірі / Өндіруші бөлшек нөмірі (MPN)", value: "mpnCode" },
                    { labelRu: "NTIN", labelKz: "NTIN", value: "ntin" },
                   
                ],
            },
            {
                key: "characteristics",
                labelRu: "Характеристики",
                labelKz: "Сипаттамалар",
                fields: [
                    // { labelRu: "Основной материал", labelKz: "Материал", value: "metal" },
                    // { labelRu: "Соответствие пробы", labelKz: "Проба", value: "purity" },
                    // { labelRu: "Покрытие", labelKz: "Қаптама", valueRu: "coatingRu", valueKz: "coatingKz" },
                    // { labelRu: "Артикул", labelKz: "Артикул", value: "article" },
                    // { labelRu: "Товарный знак", labelKz: "Тауар белгісі", value: "brand" },
                    { labelRu: "Единица измерения товара", labelKz: "Тауардың өлшем бірлігі", value: "measureUnitLabelRu" },
                    { labelRu: "Код единицы измерения", labelKz: "Өлшем бірлігінің коды", value: "measureUnitCode" },
                    { labelRu: "Масса товара без упаковки", labelKz: "Тауардың қаптамасыз салмағы", value: "weightNetto" },
                    { labelRu: "Мера измерения ", labelKz: "Өлшем (өлшем түрі)", value: "weightNettoMeasureUnitLabelRu" },
                    { labelRu: "Код меры измерения", labelKz: "Өлшем түрінің коды", value: "weightNettoMeasureUnitCode" },


                ],
            },
            {
                key: "personal",
                labelRu: "Персональные характеристики",
                labelKz: "Жеке сипаттамалар",
                fields: [
                    { labelRu: "Объем газа (в литрах)", labelKz: "Газ көлемі (литрмен)", valuePath: "gasInfo.gasVolumeLiters" },
                    { labelRu: "Уникальный код баллона(на металлической бирке)", labelKz: "ГБ түгендеу нөмірі", valuePath: "gasInfo.gasInventoryNumber" },
                    { labelRu: "Дата заполнения баллона", labelKz: "Баллонды толтыру күні", valuePath: "gasInfo.fillingDate" },
                ],
            },
            // {
            //     key: "insertion",
            //     labelRu: "Вставки",
            //     labelKz: "Кірістіру",
            //     fields: [
            //         {
            //             "insertionMaterial": "Бриллиант",
            //             "insertionCount": 3,
            //             "insertionWeight": "15"
            //         }
            //     ],
            // },
        ],
    },
    {
        id: 1,
        name: "Ювелирные изделия",
        code: "001",
        bearer: true,
        checkBox: false,
        load: true,
        categories: [
            {
                key: "card",
                labelRu: "Карточка товара",
                labelKz: "Тауар картасы",
                fields: [
                    { labelRu: "Полное наименование ЮИ", labelKz: "ЮИ толық атауы", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "Дата и время публикации", labelKz: "Жарияланған күні мен уақыты", value: "createdAt" },
                    { labelRu: "Краткое наименование ЮИ", labelKz: "ЮИ қысқаша атауы", valueRu: "shortNameRu", valueKz: "shortNameKz" },
                    // { labelRu: "ИИН/БИН создателя карточки ЮИ", labelKz: "ЮИ картасын құрғанның ЖСН/БСН", value: "applicant" },
                ],
            },
            {
                key: "description",
                labelRu: "Описание товара",
                labelKz: "Тауар сипаттамасы",
                fields: [
                    // { labelRu: "Тип изделия", labelKz: "Бұйым түрі", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "NTIN (Штрихкод)", labelKz: "NTIN (Штрихкод)", value: "ntin" },
                    // { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    // { labelRu: "Расшифровка ТНВЭД", labelKz: "ТН ВЭД түсіндірмесі", valuePath: "tnved.0.tnvedLabel" },
                    // { labelRu: "Код КПВЭД", labelKz: "КПВЭД коды", valuePath: "kpved.0.kpvedCode" },
                    // { labelRu: "Расшифровка КПВЭД", labelKz: "КПВЭД түсіндірмесі", valuePath: "kpved.0.kpvedLabel" },
                    // { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Наименование производителя", labelKz: "Өндірушінің атауы", valueRu: "producerRu", valueKz: "producerKz" },
                    { labelRu: "ИИН/БИН производителя", labelKz: "Өндірушінің ЖСН/БСН", valueRu: "producerBinIin",  },
                    { labelRu: "Товарный знак (марка, бренд) ", labelKz: "Тауар таңбасы (маркасы, бренд)", value: "brand" },
                    { labelRu: "GTIN", labelKz: "GTIN", value: "gtin" },
                    { labelRu: "Наименование кода ОКТРУ", labelKz: "ОКТРУ кодының атауы", value: "oktruLabelRu"},
                    { labelRu: "Код ОКТРУ", labelKz: "ОКТРУ коды", value: "oktruCode" },
                    { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    { labelRu: "Товар категории СЗПТ", labelKz: "СЗПТ санатындағы тауар", value: "szpt",},
                    { labelRu: "Артикул", labelKz: "Артикул (артикул нөмірі)", value: "article",},
                    { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Заводской номер / MPN", labelKz: "Зауыт нөмірі / Өндіруші бөлшек нөмірі (MPN)", value: "mpnCode" },
                    { labelRu: "NTIN", labelKz: "NTIN", value: "ntin" },
                   
                ],
            },
            {
                key: "characteristics",
                labelRu: "Характеристики",
                labelKz: "Сипаттамалар",
                fields: [
                    // { labelRu: "Основной материал", labelKz: "Материал", value: "metal" },
                    // { labelRu: "Соответствие пробы", labelKz: "Проба", value: "purity" },
                    // { labelRu: "Покрытие", labelKz: "Қаптама", valueRu: "coatingRu", valueKz: "coatingKz" },
                    // { labelRu: "Артикул", labelKz: "Артикул", value: "article" },
                    // { labelRu: "Товарный знак", labelKz: "Тауар белгісі", value: "brand" },
                    { labelRu: "Единица измерения товара", labelKz: "Тауардың өлшем бірлігі", value: "measureUnitLabelRu" },
                    { labelRu: "Код единицы измерения", labelKz: "Өлшем бірлігінің коды", value: "measureUnitCode" },
                    { labelRu: "Масса товара без упаковки", labelKz: "Тауардың қаптамасыз салмағы", value: "weightNetto" },
                    { labelRu: "Мера измерения ", labelKz: "Өлшем (өлшем түрі)", value: "weightNettoMeasureUnitLabelRu" },
                    { labelRu: "Код меры измерения", labelKz: "Өлшем түрінің коды", value: "weightNettoMeasureUnitCode" },

                ],
            },
            // {
            //     key: "insertion",
            //     labelRu: "Вставки",
            //     labelKz: "Кірістіру",
            //     fields: [
            //         {
            //             "insertionMaterial": "Бриллиант",
            //             "insertionCount": 3,
            //             "insertionWeight": "15"
            //         }
            //     ],
            // },
        ],
    },
    {
        id: 4,
        name: "Дериваты",
        code: "004",
        bearer: false,
        checkBox: true,
        load: false,
        categories: [
            {
                key: "card",
                labelRu: "Карточка товара",
                labelKz: "Тауар картасы",
                fields: [
                    { labelRu: "Полное наименование ЮИ", labelKz: "ЮИ толық атауы", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "Дата и время публикации", labelKz: "Жарияланған күні мен уақыты", value: "createdAt" },
                    { labelRu: "Краткое наименование ЮИ", labelKz: "ЮИ қысқаша атауы", valueRu: "shortNameRu", valueKz: "shortNameKz" },
                    // { labelRu: "ИИН/БИН создателя карточки ЮИ", labelKz: "ЮИ картасын құрғанның ЖСН/БСН", value: "applicant" },
                ],
            },
            {
                key: "description",
                labelRu: "Описание товара",
                labelKz: "Тауар сипаттамасы",
                fields: [
                    // { labelRu: "Тип изделия", labelKz: "Бұйым түрі", valueRu: "nameRu", valueKz: "nameKz" },
                    // { labelRu: "NTIN (Штрихкод)", labelKz: "NTIN (Штрихкод)", value: "ntin" },
                    // { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    // { labelRu: "Расшифровка ТНВЭД", labelKz: "ТН ВЭД түсіндірмесі", valuePath: "tnved.0.tnvedLabel" },
                    // { labelRu: "Код КПВЭД", labelKz: "КПВЭД коды", valuePath: "kpved.0.kpvedCode" },
                    // { labelRu: "Расшифровка КПВЭД", labelKz: "КПВЭД түсіндірмесі", valuePath: "kpved.0.kpvedLabel" },
                    // { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Наименование производителя", labelKz: "Өндірушінің атауы", valueRu: "producerRu", valueKz: "producerKz" },
                    { labelRu: "ИИН/БИН производителя", labelKz: "Өндірушінің ЖСН/БСН", valueRu: "producerBinIin",  },
                    { labelRu: "Товарный знак (марка, бренд) ", labelKz: "Тауар таңбасы (маркасы, бренд)", value: "brand" },
                    { labelRu: "GTIN", labelKz: "GTIN", value: "gtin" },
                    { labelRu: "Наименование кода ОКТРУ", labelKz: "ОКТРУ кодының атауы", value: "oktruLabelRu"},
                    { labelRu: "Код ОКТРУ", labelKz: "ОКТРУ коды", value: "oktruCode" },
                    { labelRu: "Код ТНВЭД", labelKz: "ТН ВЭД коды", valuePath: "tnved.0.tnvedCode" },
                    { labelRu: "Товар категории СЗПТ", labelKz: "СЗПТ санатындағы тауар", value: "szpt",},
                    { labelRu: "Артикул", labelKz: "Артикул (артикул нөмірі)", value: "article",},
                    { labelRu: "Страна производства", labelKz: "Өндіріс елі", value: "countryName" },
                    { labelRu: "Заводской номер / MPN", labelKz: "Зауыт нөмірі / Өндіруші бөлшек нөмірі (MPN)", value: "mpnCode" },
                    { labelRu: "NTIN", labelKz: "NTIN", value: "ntin" },
                   
                ],
            },
            {
                key: "characteristics",
                labelRu: "Характеристики",
                labelKz: "Сипаттамалар",
                fields: [
                    // { labelRu: "Основной материал", labelKz: "Материал", value: "metal" },
                    // { labelRu: "Соответствие пробы", labelKz: "Проба", value: "purity" },
                    // { labelRu: "Покрытие", labelKz: "Қаптама", valueRu: "coatingRu", valueKz: "coatingKz" },
                    // { labelRu: "Артикул", labelKz: "Артикул", value: "article" },
                    // { labelRu: "Товарный знак", labelKz: "Тауар белгісі", value: "brand" },
                    { labelRu: "Единица измерения товара", labelKz: "Тауардың өлшем бірлігі", value: "measureUnitLabelRu" },
                    { labelRu: "Код единицы измерения", labelKz: "Өлшем бірлігінің коды", value: "measureUnitCode" },
                    { labelRu: "Масса товара без упаковки", labelKz: "Тауардың қаптамасыз салмағы", value: "weightNetto" },
                    { labelRu: "Мера измерения ", labelKz: "Өлшем (өлшем түрі)", value: "weightNettoMeasureUnitLabelRu" },
                    { labelRu: "Код меры измерения", labelKz: "Өлшем түрінің коды", value: "weightNettoMeasureUnitCode" },

                ],
            },
            {
                key: "personal",
                labelRu: "Персональные характеристики",
                labelKz: "Жеке сипаттамалар",
                fields: [
                    { labelRu: "Длина рога (см)", labelKz: "Мүйіз ұзындығы (см)", valuePath: "derivativeInfo.hornLengthCm" },
                    { labelRu: "Дата изъятия", labelKz: "Алу күні", valuePath: "derivativeInfo.extractionDate" },
                    { labelRu: "Источник происхождения (код)", labelKz: "Шығу көзі (код)", valuePath: "derivativeInfo.sourceCode" },
                    { labelRu: "Сорт", labelKz: "Сорт", valuePath: "derivativeInfo.sort" },
                    { labelRu: "Сотрудник", labelKz: "Қызметкер", valuePath: "derivativeInfo.employee" },
                ],
            },
            // {
            //     key: "insertion",
            //     labelRu: "Вставки",
            //     labelKz: "Кірістіру",
            //     fields: [
            //         {
            //             "insertionMaterial": "Бриллиант",
            //             "insertionCount": 3,
            //             "insertionWeight": "15"
            //         }
            //     ],
            // },
        ],
    },
]);